<!--
 * @Author: yangchuanqi
 * @Date: 2021-01-04 14:58:53
 * @LastEditTime: 2021-01-07 15:50:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\appeal\appealDo.vue
-->
<template>
    <div style="width: 1200px">
        <div class="tablez_bg">
            <div class="title">
                您当前的位置：
                <router-link to="/home">阳光校务服务大厅</router-link>
                &gt; 师生诉求
            </div>
        </div>
        <div class="z_title1" style="margin-top: 10px">{{ record.name }}</div>
        <div style="margin-top: 15px">
            <span style="color: #e4ae2a">使用帮助：</span>
            <span style="color: #666; font-weight: 600"
            >政策咨询”栏目主要受理个人和单位在对我厅办事过程中有关法规、政策、程序等问题的咨询，一般由各业务处室
        作出解答。该栏目答复是一种指导性意见，不具有法定效力。具体问题要通过法定途径（诉讼、复议、信访等）解决。</span
            >
        </div>
        <div style="margin-top: 10px; background-color: #ddd; padding: 10px">
            <div>1.欢迎您为大学建设与发展建言献策。</div>
            <div>2.请您认真填写带*的必写栏目。</div>
            <div>
                3.信件提交后，受理单位将在规定期限内办复，即一般问题在受理后1~3个工作日办复；情况复杂的有可能适当延长，但最长不会超过7个工作日。
                对于有些重大问题，无法在7个工作日回复的，我们会及时转送学校。请您留意本站办理情况，或输入受理编号进行查询。
            </div>
            <div>
                4.相同内容信件请勿重复提交或一信多投，即对重复提交的，如该问题正在受理期内将不再重复受理。
            </div>
            <!--      <div style="margin-top: 10px; color: red">-->
            <!--        注：报修项目请详细准确填写楼栋、楼层、房间号、需维修物物品及数量。-->
            <!--      </div>-->
        </div>

        <div class="formBody">
            <div class="formItem">
                <div class="formItemLeft">
                    <span style="color: red">*</span>服务类型：
                </div>
                <div class="formItemRight" style="font-weight: 600">
                    {{ record.name }}
                </div>
            </div>
            <div v-if="typeShow" class="formItem">
                <div class="formItemLeft">
                    <span style="color: red">*</span>问题类别：
                </div>
                <div class="formItemRight">
                    <a-tabs @change="callback" v-model="form.typeTwo">
                        <a-tab-pane v-for="item in record.list" :key="item.id" :tab="item.name">
                            <a-radio-group name="radioGroup" v-model="type">
                                <a-radio v-for="(item1, index1) in item.list" :key="index1" :value="item1">
                                    {{ item1.name }}
                                </a-radio>
                            </a-radio-group>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
            <div class="formItem">
                <div class="formItemLeft"><span style="color: red">*</span>标题：</div>
                <div class="formItemRight">
                    <a-input v-model="form.name" style="width: 50%"></a-input>
                </div>
            </div>
            <div class="formItem">
                <div class="formItemLeft"><span style="color: red">*</span>内容：</div>
                <div class="formItemRight">
                    <div ref="editor" style="text-align: left; z-index: 10"></div>
                </div>
            </div>
            <div class="formItem">
                <div class="formItemLeft"><span style="color: red">*</span>手机号码：</div>
                <div class="formItemRight">
                    <a-input v-model="form.mobile" style="width: 50%"></a-input>
                    <a-input-search style="width:300px;margin-left: 10px;" @search="showImgCode" placeholder="请输入验证码"
                                    v-model="form.mobileCode">
                        <a-button :disabled="yzText !== '获取验证码'" slot="enterButton">
                            {{ yzText }}
                        </a-button>
                    </a-input-search>
                </div>
            </div>
            <div v-show="record.name==='我要投诉'||record.name==='我要咨询'" class="formItem">
                <div class="formItemLeft"><span style="color: red">*</span>所属院系/身份：</div>
                <div class="formItemRight">
                    <a-select @change="collegeChange" style="width: 50%" v-model="form.college" placeholder="请选择">
                        <a-select-option value="人文学院">人文学院</a-select-option>
                        <a-select-option value="数理系">数理系</a-select-option>
                        <a-select-option value="信息系">信息系</a-select-option>
                        <a-select-option value="学前教育学院">学前教育学院</a-select-option>
                        <a-select-option value="外语系">外语系</a-select-option>
                        <a-select-option value="音乐艺术系">音乐艺术系</a-select-option>
                        <a-select-option value="美术系">美术系</a-select-option>
                        <a-select-option value="文旅学院">文旅学院</a-select-option>
                        <a-select-option value="教职工">教职工</a-select-option>
                        <a-select-option value="校外人员">校外人员</a-select-option>
                        <a-select-option value="其他">其他</a-select-option>
                    </a-select>
                </div>
            </div>
            <div v-show="record.name==='我要投诉'" class="formItem">
                <div class="formItemLeft"><span style="color: red">*</span>是否匿名发布：</div>
                <div class="formItemRight">
                    <a-radio-group v-model="form.userType">
                        <a-radio :value="3">是</a-radio>
                        <a-radio :value="1">否</a-radio>
                    </a-radio-group>
                </div>
            </div>
            <div v-if="form.userType===1">
                <div class="formItem">
                    <div class="formItemLeft"><span style="color: red">*</span>姓名：</div>
                    <div class="formItemRight">
                        <a-input v-model="form.userName" style="width: 50%"></a-input>
                    </div>
                </div>
                <div class="formItem">
                    <div class="formItemLeft"><span style="color: red">*</span>联系方式：</div>
                    <div class="formItemRight">
                        <a-input v-model="form.email" style="width: 50%"></a-input>
                    </div>
                </div>
                <div class="formItem">
                    <div class="formItemLeft">学号/教师工号：</div>
                    <div class="formItemRight">
                        <a-input v-model="form.workNo" style="width: 50%"></a-input>
                    </div>
                </div>
                <div class="formItem">
                    <div class="formItemLeft">地址：</div>
                    <div class="formItemRight">
                        <a-input v-model="form.address" style="width: 50%"></a-input>
                    </div>
                </div>
            </div>
            <div class="formItem">
                <div class="formItemLeft">附件：</div>
                <div class="formItemRight">
                    <a-upload name="file" :multiple="false" :file-list="fileList" :beforeUpload="beforeUpload"
                              :action="action" @change="handleChange">
                        <a-button>
                            <a-icon type="upload"/>
                            点击上传
                        </a-button>
                    </a-upload>
                    <div style="font-size: 13px">
                        1.支持(gif,jpg,jpeg,doc,docx,txt,xls,xlsx,zip,rar,bmp,chm,pdf,png)格式，最大上传附件为15M
                    </div>
                    <div style="font-size: 13px">
                        2.如需上传多个文件请先在本地打包后再上传。
                    </div>
                </div>
            </div>
            <div style="width: 100%; text-align: center; padding: 20px">
                <a-button :loading="loading" size="large" @click="submit" type="primary">提 交</a-button>
            </div>
        </div>
        <a-modal title="图形验证码" :visible="imageCodeModal" @ok="onSearch" @cancel="imageCodeModal = false">
            <a-form>
                <a-form-item style="display: flex;align-items: center;justify-content: space-between"
                             :labelCol="labelCol" :wrapperCol="wrapperCol" label="图形验证码">
                    <a-input style="width: 60%" v-model="imageCode" placeholder="请输入图形验证码"></a-input>
                    <img style="margin-left: 10px" :src="imgCode" @click="getImgCode" alt="">
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";
import E from "wangeditor";

var editor;
export default {
    data() {
        return {
            record: {},
            radio: 1,
            labelCol: {
                xs: {span: 24},
                sm: {span: 5},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
            },
            form: {
                content: "",
                email: "",
                filePath: "",
                mobile: "",
                name: "",
                mobileCode: "",
                typeOne: 0,
                typeThree: null,
                typeTwo: null,
                userName: "",
                userType: 1,
                qqCode: "",
                workNo: "",
                college: "",
            },
            type: null,
            fileList: [],
            typeShow: false,
            action: window._CONFIG["url"] + "/common/file/uploadByJava",
            yzText: '获取验证码',
            time: 60,
            timer: null,
            loading: false,
            imageCodeModal: false,
            imageCode: '',
            imgCode: '',
        };
    },
    methods: {
        showImgCode() {
            if (!this.form.mobile) {
                this.$message.error('请先输入手机号码！')
                return
            }
            this.imageCode = ''
            this.imgCode = ''
            this.getImgCode()
            this.imageCodeModal = true
        },
        getImgCode() {
            getAction('/sys/getRandomImage?mobile=' + this.form.mobile).then((data) => {
                this.imgCode = data.data
            })
        },
        collegeChange() {
            if (this.form.college === '其他') {
                this.$warning({
                    title: '提示',
                    content: `不能有针对性的调查问题，会降处理问题的时效性`,
                });
            }
        },
        codeTime() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.time = TIME_COUNT;
                this.yzText = this.time + "秒后重新发送";
                //这里可以插入$axios调用后台接口
                this.timer = setInterval(() => {
                    if (this.time > 0 && this.time <= TIME_COUNT) {
                        this.time--;
                        this.yzText = this.time + "秒后重新发送";
                    } else {
                        this.yzText = "获取验证码";
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        onSearch(value, event) {
            if (!this.imageCode) {
                this.$message.error('请输入验证码')
                return false
            }
            if (this.yzText !== '获取验证码') {
                return
            }

            if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.mobile))) {
                this.$notification["error"]({
                    message: "提示",
                    description: "手机号码有误，请重填",
                });
                return false;
            }
            getAction("/sys/sendSms", {mobile: this.form.mobile, code: this.imageCode}).then((data) => {
                if (data.code === 0) {
                    this.$message.success("发送成功!");
                    this.imageCodeModal = false
                    this.codeTime();
                } else {
                    this.$message.error(data.message);
                }
            });
        },
        onChange() {
        },
        callback() {
        },
        handleChange({file, fileList, event}) {
            if (file.status === "done") {
                if (file.response.code === 0) {
                    this.$notification["success"]({
                        message: "提示",
                        description: `${file.name} 上传成功！`,
                    });
                } else if (file.response.code === 500) {
                    fileList.pop();
                    this.$notification["error"]({
                        message: "提示",
                        description: `${file.name} 上传失败！`,
                    });
                }
            } else if (file.status === "error") {
                fileList.pop();
                this.$notification["error"]({
                    message: "提示",
                    description: `${file.name} 上传失败！`,
                });
            } else if (file.status === "removed") {
            }
            this.fileList = fileList;
        },
        beforeUpload(file) {
            let _this = this;
            return new Promise((resolve, reject) => {
                const isType = /\.(gif|jpg|jpeg|doc|docx|txt|xlsx|zip|rar|bmp|chm|pdf|png)$/.test(
                    file.name
                );
                const fileLength = _this.fileList.length > 0;
                const isLt15M = file.size / 1024 / 1024 < 15;
                if (!isType) {
                    _this.$notification["error"]({
                        message: "提示",
                        description:
                            "上传文件格式应为gif,jpg,jpeg,doc,docx,txt,xls,xlsx,zip,rar,bmp,chm,pdf,png！",
                    });

                    return reject(false);
                }
                if (!isLt15M) {
                    _this.$notification["error"]({
                        message: "提示",
                        description: "上传大小不能超过 15MB！",
                    });
                    return reject(false);
                }
                if (fileLength) {
                    _this.$notification["error"]({
                        message: "提示",
                        description: "只能上传一个文件！",
                    });
                    return reject(false);
                }
                return resolve(true);
            });
            return isType && !fileLength && isLt15M;
        },
        submit() {
            let _this = this;
            if (!this.form.name) {
                _this.$notification["error"]({
                    message: "提示",
                    description: "请输入诉求标题",
                });
                return;
            }
            if ((this.record.name === '我要投诉' || this.record.name === '我要咨询') && !this.form.college) {
                _this.$notification["error"]({
                    message: "提示",
                    description: "请选择所属学院",
                });
                return;
            }
            if (!editor.txt.html()) {
                _this.$notification["error"]({
                    message: "提示",
                    description: "请输入诉求内容",
                });
                return;
            }
            if (!this.form.mobile) {
                _this.$notification["error"]({
                    message: "提示",
                    description: "请输入手机号码",
                });
                return;
            }
            if (!this.form.mobileCode) {
                _this.$notification["error"]({
                    message: "提示",
                    description: "请输入短信验证码",
                });
                return;
            }
            if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.mobile))) {
                _this.$notification["error"]({
                    message: "提示",
                    description: "手机号码有误，请重填",
                });
                return false;
            }
            if (this.form.userType === 1) {
                if (!this.form.userName) {
                    _this.$notification["error"]({
                        message: "提示",
                        description: "请输入姓名",
                    });
                    return;
                }
                if (!this.form.email) {
                    _this.$notification["error"]({
                        message: "提示",
                        description: "请输入联系方式",
                    });
                    return;
                }
            }
            _this.loading = true
            if (this.type !== null) {
                this.form.orgId = this.type.orgId;
                this.form.typeThree = this.type.id;
            } else {
                this.form.orgId = this.record.orgId;
                this.form.typeThree = null;
            }
            this.form.content = editor.txt.html();
            if (this.fileList.length > 0)
                this.form.filePath = this.fileList[0].response.data;
            postAction("/user/appeal/appeal/add", this.form).then((data) => {
                if (data.code === 0) {
                    _this.loading = false
                    _this.$notification["success"]({
                        message: "提示",
                        description: "操作成功！您的受理单号为" + data.data + "，请根据此单号进行搜索查询",
                        duration: 5,
                    });
                    _this.$router.replace("/home");
                } else {
                    _this.loading = false
                    _this.$notification["error"]({
                        message: "提示",
                        description: data.message,
                    });
                }
            }).catch(() => {
                _this.loading = false
            })
        },
    },
    mounted() {
        this.record = JSON.parse(decodeURIComponent(this.$route.query.record));
        this.form.typeOne = this.record.id;
        this.form.userType = 1
        if (this.record.list.length > 0) {
            this.typeShow = true;
            this.form.typeTwo = this.record.list[0].id;
            this.type = this.record.list[0].list[0];
        } else {
            this.typeShow = false;
            this.form.typeTwo = null;
            this.type = null;
        }
        let That = this;
        editor = new E(this.$refs.editor);
        editor.customConfig = {
            onchange: function (html) {
                That.Content = html;
            },
        };
        editor.config.zIndex = 100;
        editor.config.excludeMenus = ["image", "video"];
        editor.create();

    },
};
</script>

<style scoped>
.itemsList {
    margin-top: 20px;
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.formBody {
    border: 1px solid #e6e6e6;
    margin-top: 10px;
}

.formItem {
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
}

.formItemLeft {
    width: 20%;
    text-align: right;
    padding: 10px;
    font-size: 16px;
}

.formItemRight {
    width: 80%;
    padding: 10px;
    border-left: 1px solid #e6e6e6;
    font-size: 16px;
}
</style>
